
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[identifier]",
      function () {
        return require("private-next-pages/blog/[identifier].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[identifier]"])
      });
    }
  